import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_2 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, null, -1)

import { ref, onMounted, watch } from "vue";
import AccountOverviewService from "@/projects/tenant/views/accountOverview/services/AccountOverviewServices";
// import i18n from "@/core/plugins/i18n";
import { TransactionAccountType } from "@/core/types/StateInfos";

export default /*#__PURE__*/_defineComponent({
  __name: 'accountTransfer',
  props: {
  account: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const isLoading = ref(false);
const data = ref<any>([]);
// const { t } = i18n.global;



const criteria = ref({
  size: 10,
  accountId: props.account.id,
} as any);

const fetchData = async (_page: number) => {
  if (props.account.accountNumber === undefined) return;
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const res = await AccountOverviewService.queryTransactions(criteria.value);
    criteria.value = res.criteria;
    data.value = res.data;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

watch(
  () => props.account,
  (newAccount, oldAccount) => {
    if (newAccount && newAccount.id !== oldAccount?.id) {
      resetCriteria();
      fetchData(1);
    }
  },
  { deep: true }
);

const resetCriteria = () => {
  criteria.value = {
    size: 10,
    accountId: props.account.id,
    accountNumber: props.account.accountNumber,
    serviceId: props.account.serviceId,
  };
};

onMounted(() => {
  fetchData(1);
});

const pageChange = (page: number) => {
  criteria.value.page = page;
  fetchData(page);
};

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_BalanceShow = _resolveComponent("BalanceShow")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_2, [
          _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t("fields.client")), 1),
          _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t("fields.source")), 1),
          _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t("fields.target")), 1),
          _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("fields.amount")), 1),
          _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("fields.createdOn")), 1)
        ])
      ]),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
            _createVNode(_component_LoadingRing)
          ]))
        : (!isLoading.value && data.value.length === 0)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
              _createVNode(_component_NoDataBox)
            ]))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_11, [
                    (item.user)
                      ? (_openBlock(), _createBlock(_component_UserInfo, {
                          key: 0,
                          user: item.user,
                          class: "me-2"
                        }, null, 8, ["user"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_12, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t(`type.transactionAccount.${item.sourceAccountType}`) +
              " " +
              (item.sourceAccountType === _unref(TransactionAccountType).Wallet
                ? _ctx.$t(`type.currency.${item.currencyId}`)
                : item.sourceAccountNumber)), 1),
                    _createElementVNode("div", null, [
                      _createVNode(_component_BalanceShow, {
                        class: "fw-bold",
                        balance: item.sourceAccountBalanceInCents,
                        "currency-id": item.currencyId
                      }, null, 8, ["balance", "currency-id"])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_13, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t(`type.transactionAccount.${item.targetAccountType}`) +
              " " +
              (item.targetAccountType === _unref(TransactionAccountType).TradeAccount
                ? item.targetAccountNumber
                : _ctx.$t(`type.currency.${item.currencyId}`))), 1),
                    _createElementVNode("div", null, [
                      _createVNode(_component_BalanceShow, {
                        class: "fw-bold",
                        balance: item.targetAccountBalanceInCents,
                        "currency-id": item.currencyId
                      }, null, 8, ["balance", "currency-id"])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_14, [
                    _createVNode(_component_BalanceShow, {
                      class: "fw-bold",
                      balance: item.amount,
                      "currency-id": item.currencyId
                    }, null, 8, ["balance", "currency-id"])
                  ]),
                  _createElementVNode("td", _hoisted_15, [
                    _createVNode(_component_TimeShow, {
                      "date-iso-string": item.createdOn
                    }, null, 8, ["date-iso-string"])
                  ]),
                  _hoisted_16
                ]))
              }), 128))
            ]))
    ]),
    _createVNode(_component_TableFooter, {
      onPageChange: pageChange,
      criteria: criteria.value
    }, null, 8, ["criteria"])
  ], 64))
}
}

})